<template>
  <div class="bb-number-row">
    {{ index + 1 }}
  </div>
</template>

<script>

export default {
  name: 'NumberRow',
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/variables";

  .bb-number-row {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 18px;
    width: 18px;
    border-radius: 50%;
    background: rgba($color-denim, 0.15);
    color: $color-denim;
    font-size: 11px;
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/NumberRow/NumberRow.vue